/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import CallIcon from '@material-ui/icons/Call';
import React from 'react';
import { compose } from 'redux';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import OrderCallButtonPropTypes from './OrderCallButton.component.props';
import orderCallButtonStyles from './OrderCallButton.component.styles';

/**
 * OrderCallButtonComponent
 * @export
 * @class OrderCallButtonComponent
 * @extends {React.Component<OrderCallButtonComponentComposedProps, OrderCallButtonComponentState>}
 */
export class OrderCallButtonComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderCallButtonComponentProps>}
   * @memberof OrderCallButtonComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderCallButton`}
   * @memberof OrderCallButtonComponent
   */
  static displayName = `OrderCallButton`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderCallButtonComponent
   */
  static propTypes = OrderCallButtonPropTypes;

  /**
   * Data specific to the `<OrderCallButtonComponent />` instance
   * @type {OrderCallButtonComponentState}
   * @memberof OrderCallButtonComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderCallButtonComponent />`
   * @memberof OrderCallButtonComponent
   */
  render() {
    const { contactNumber, classes, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    const contactNumberDisplay = isSmall ? `` : contactNumber;
    return (
      <Button className={classes.callToAction} color="secondary" fullWidth={isSmall || isLarge} href={`tel:${contactNumber}`} variant="contained">
        <Grid container justify="space-between">
          <I18n className={classes.callBoral} data={{ contactNumber: contactNumberDisplay }} textTransform="none" variant="subtitle1">
            OrderService.CallBoral
          </I18n>
        </Grid>
        <CallIcon className={classes.callIcon} />
      </Button>
    );
  }
}

/** @type {React.ComponentClass<OrderCallButtonComponentProps>} */
const OrderCallButton = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderCallButtonStyles), { withTheme: true }),
)(OrderCallButtonComponent);

export default OrderCallButton;
